import 'dayjs/locale/fr';
import './styles/app.scss';
import './styles/fonts.scss';

import AgendaPage                       from '@/pages/Agenda/AgendaPage';
import CandidaciesPage                  from '@/pages/Candidacies/CandidaciesPage';
import ConfirmationEmailPage            from '@/pages/ConfirmationEmail/ConfirmationEmailPage';
import ConfirmationRegistrationPage     from '@/pages/ConfirmationRegistration/ConfirmationRegistrationPage';
import ConfirmationResetPassword        from '@/pages/ConfirmationResetPassword/ConfirmationResetPassword';
import DaisukiPage                      from '@/pages/Daisuki/DaisukiPage';
import HomePage                         from '@/pages/Home/HomePage';
import LoginPage                        from '@/pages/Login/LoginPage';
import NotFoundPage                     from '@/pages/NotFound/NotFoundPage';
import PersonalInformationPage          from '@/pages/PersonalInformation/PersonalInformationPage';
import ProtectedRoute                   from '@/routes/protectedRoute';
import React                            from 'react';
import RegistrationPage                 from '@/pages/Registration/RegistrationPage';
import ResetPasswordPage                from '@/pages/ResetPassword/ResetPasswordPage';
import { Route }                        from 'react-router-dom';
import { useSearchParams }              from 'react-router-dom';
import { Routes }                       from 'react-router-dom';
import SecurityPage                     from '@/pages/Security/SecurityPage';
import SettingsPage                     from '@/pages/Settings/SettingsPage';
import TicketPage                       from '@/pages/Ticket/TicketPage';
import TicketsPage                      from '@/pages/Tickets/TicketsPage';
import TransfersPage                    from '@/pages/Transfers/TransfersPage';
import TranslatedRoute                  from '@/routes/translatedRoute';
import dayjs                            from 'dayjs';
import { getLocale }                    from '@widesk-core/locale';
import { useLocation }                  from 'react-router-dom';
import useTranslations                  from '@/hooks/useTranslations';
import ContactsPage                     from '@/pages/Contacts/ContactsPage';
import useFetch                         from '@widesk-core/hooks/useFetch';
import authStore                        from '@/stores/authStore';
import UserMeModel                      from '@/models/services/fondations/UserMeModel';
import { useNavigate }                  from 'react-router-dom';
import { useTranslation }               from 'react-i18next';
import { initGoogleAnalytics }          from '@/tools/analytics'
import { initCookiebot }                from '@/tools/cookiebot'
import NewslettersPage                  from '@/pages/Newsletters/NewslettersPage';
import StandsPage                       from '@/pages/Stands/StandsPage';
import EditStandPage                    from '@/pages/Stand/EditStandPage';
import EntitiesPage                     from '@/pages/Entity/EntitiesPage';
import EntityPage                       from '@/pages/Entity/EntityPage';

dayjs.locale(getLocale());

export default function App() {
    const { i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { getNavigationTranslation, validateLanguage } = useTranslations();

    // Cookiebot doit être chargé sur tous les environnements déployés (dev, demo, préproduction, production), sauf en local
    if (import.meta.env.PROD) {
        initCookiebot('32efb2a0-19ba-44c0-b90d-3f0ce54bbc26');
    }

    if (process.env.NODE_ENV === 'production') {
        initGoogleAnalytics('G-6RHP0EPY99');
    }

    useFetch(async () => {
        // Si il existe un token dans l'url pour impersonate un user
        const token = searchParams.get('impersonate');
        if(token) {
            try {
                authStore.impersonate(token);
    
                const user = await new UserMeModel().fetch();
                authStore.setCurrentUser(user);
                
                navigate(`/${i18n.language}/`);
            } catch (error) {
                console.log(error);
            }

        }
    }, true);
    

    React.useEffect(() => {
        
        // Vérifier le language de l'application à chaque changement d'url
        validateLanguage();
        
    }, [location.pathname]);
    
    return (
        <Routes>
            <Route element={<TranslatedRoute />}>
                {/* Routes publiques */}
                <Route path={getNavigationTranslation('login', 'path')} element={<LoginPage />} />
                <Route path={getNavigationTranslation('registration', 'path')} element={<RegistrationPage />} />
                <Route path={getNavigationTranslation('resetPassword', 'path')} element={<ResetPasswordPage />} />
                <Route path={getNavigationTranslation('confirmationEmail', 'path')} element={<ConfirmationEmailPage />} />
                <Route path={getNavigationTranslation('confirmationRegistration', 'path')} element={<ConfirmationRegistrationPage />} />
                <Route path={getNavigationTranslation('confirmationResetPassword', 'path')} element={<ConfirmationResetPassword />} />
                
                {/* Routes protégées */}
                <Route element={<ProtectedRoute />}>
                    <Route path={getNavigationTranslation('home', 'path')} element={<HomePage />} />
                    <Route path={getNavigationTranslation('personalInformation', 'path')} element={<PersonalInformationPage />} />
                    <Route path={getNavigationTranslation('settings', 'path')} element={<SettingsPage />} />
                    <Route path={getNavigationTranslation('security', 'path')} element={<SecurityPage />} />
                    <Route path={getNavigationTranslation('entities', 'path')} element={<EntitiesPage />} />
                    <Route path={`${getNavigationTranslation('entity', 'path')}/:entityId`} element={<EntityPage />} />
                    <Route path={getNavigationTranslation('stands', 'path')} element={<StandsPage />} />
                    <Route path={`${getNavigationTranslation('editStand', 'path')}/:standId`} element={<EditStandPage />} />
                    <Route path={getNavigationTranslation('contacts', 'path')} element={<ContactsPage />} />
                    <Route path={getNavigationTranslation('newsletters', 'path')} element={<NewslettersPage />} /> 
                    <Route path={getNavigationTranslation('tickets', 'path')} element={<TicketsPage />} />
                    <Route path={`${getNavigationTranslation('ticket', 'path')}/:codeValue`} element={<TicketPage />} />
                    <Route path={getNavigationTranslation('transfers', 'path')} element={<TransfersPage />} />
                    <Route path={getNavigationTranslation('daisuki', 'path')} element={<DaisukiPage />} />
                    <Route path={getNavigationTranslation('agenda', 'path')} element={<AgendaPage />} />
                    <Route path={getNavigationTranslation('candidacies', 'path')} element={<CandidaciesPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Route>
        </Routes>
    );
}